import React from 'react';

export const EventTicketStatus = [
  {
    label: 'Available',
    className: 'available',
  },
  {
    label: 'Your Selection',
    className: 'your-selection',
  },
];

export const EventTablesInfo = {
  firstRow: [
    {
      name: 'table 1',
      booked: false,
      className: 'table-1 table-image',
      capacity: 3,
      id: 1,
      imageSelected: false,
    },
    {
      name: 'table 2',
      booked: true,
      className: 'table-2 table-image',
      capacity: 2,
      id: 2,
      imageSelected: false,
    },
    {
      name: 'table 3',
      booked: false,
      className: 'table-3 table-image',
      capacity: 8,
      id: 3,
      imageSelected: false,
    },
    {
      name: 'table 4',
      booked: false,
      className: 'table-4 table-image',
      capacity: 2,
      id: 4,
      imageSelected: false,
    },
    {
      name: 'table 5',
      booked: false,
      className: 'table-5 table-image',
      capacity: 3,
      id: 5,
      imageSelected: false,
    },
  ],
  secondRow: [
    {
      name: 'table 6',
      booked: false,
      className: 'table-1 table-image',
      capacity: 3,
      id: 6,
      imageSelected: false,
    },
    {
      name: 'table 7',
      booked: false,
      className: 'table-2 table-image',
      capacity: 2,
      id: 7,
      imageSelected: false,
    },
    {
      name: 'table 8',
      booked: false,
      className: 'table-3 table-image',
      capacity: 8,
      id: 8,
      imageSelected: false,
    },
    {
      name: 'table 9',
      booked: false,
      className: 'table-4 table-image',
      capacity: 2,
      id: 9,
      imageSelected: false,
    },
    {
      name: 'table 10',
      booked: false,
      className: 'table-5 table-image',
      capacity: 3,
      id: 10,
      imageSelected: false,
    },
  ],
  thirdRow: [
    {
      name: 'table 11',
      booked: false,
      className: 'table-1 table-image',
      capacity: 3,
      id: 11,
      imageSelected: false,
    },
    {
      name: 'table 12',
      booked: false,
      className: 'table-2 table-image',
      capacity: 2,
      id: 12,
      imageSelected: false,
    },
    {
      name: 'table 13',
      booked: false,
      className: 'table-3 table-image',
      capacity: 8,
      id: 13,
      imageSelected: false,
    },
    {
      name: 'table 14',
      booked: false,
      className: 'table-4 table-image',
      capacity: 2,
      id: 14,
      imageSelected: false,
    },
    {
      name: 'table 15',
      booked: false,
      className: 'table-5 table-image',
      capacity: 3,
      id: 15,
      imageSelected: false,
    },
  ],
  fourthRow: [
    {
      name: 'table 16',
      booked: false,
      className: 'table-1 table-image',
      capacity: 3,
      id: 16,
      imageSelected: false,
    },
    {
      name: 'table 17',
      booked: false,
      className: 'table-2 table-image',
      capacity: 2,
      id: 17,
      imageSelected: false,
    },
    {
      name: 'table 18',
      booked: false,
      className: 'table-3 table-image',
      capacity: 8,
      id: 18,
      imageSelected: false,
    },
    {
      name: 'table 19',
      booked: false,
      className: 'table-4 table-image',
      capacity: 2,
      id: 19,
      imageSelected: false,
    },
    {
      name: 'table 20',
      booked: false,
      className: 'table-5 table-image',
      capacity: 3,
      id: 20,
      imageSelected: false,
    },
  ],
  fifthRow: [
    {
      name: 'table 21',
      booked: false,
      className: 'table-1 table-image',
      capacity: 3,
      id: 21,
      imageSelected: false,
    },
    {
      name: 'table 22',
      booked: false,
      className: 'table-2 table-image',
      capacity: 2,
      id: 22,
      imageSelected: false,
    },
    {
      name: 'table 23',
      booked: false,
      className: 'table-3 table-image',
      capacity: 8,
      id: 23,
      imageSelected: false,
    },
    {
      name: 'table 24',
      booked: false,
      className: 'table-4 table-image',
      capacity: 2,
      id: 24,
      imageSelected: false,
    },
    {
      name: 'table 25',
      booked: false,
      className: 'table-5 table-image',
      capacity: 3,
      id: 25,
      imageSelected: false,
    },
  ],
  cornerRow: [
    {
      name: 'corner table 1',
      booked: false,
      className: 'corner-table-1 table-image',
      capacity: 2,
      id: 26,
      imageSelected: false,
    },
    {
      name: 'corner table 2',
      booked: false,
      className: 'corner-table-2 table-image',
      capacity: 2,
      id: 27,
      imageSelected: false,
    },
  ],
};
